import { render, staticRenderFns } from "./line-hr.vue?vue&type=template&id=2fd2793c&scoped=true"
import script from "./line-hr.vue?vue&type=script&lang=js"
export * from "./line-hr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2793c",
  null
  
)

export default component.exports